const groupA = [
  {
    name: 'Shisha Cafe ＆ Bar Spring Sun',
    area: '東京・江戸川区',
    address: '東京都江戸川区',
    description: 'Spring Sun Bowlを体験できる公式シーシャバー。落ち着いた和の空間でドバイスタイルのシーシャをお楽しみいただけます。',
    tags: ['公式取扱店', 'シーシャバー'],
    image: 'https://static.readdy.ai/image/b527836e8796ae62dd89bb5aa8620183/9ae3898f1ce3a8a92fa3daa8af3ee440.jpeg',
    link: 'https://shisha-springsun.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp_77876565432123321121',
  },
];

const groupB = [
  {
    name: 'シーシャ羽',
    area: '東京・葛飾区',
    address: '東京都葛飾区',
    description: '新小岩の美味しいシーシャを立ちあげるシーシャバー',
    tags: ['取扱店', 'カフェ'],
    image: 'https://static.readdy.ai/image/b527836e8796ae62dd89bb5aa8620183/eb6c248280b94b636978ff75c036c996.jpeg',
    link: 'https://www.instagram.com/shishabane/',
  },
  {
    name: 'Shisha Cafe humo',
    area: '大阪・心斎橋',
    address: '大阪府大阪市中央区',
    description: '大阪心斎橋の美味しいシーシャを立ちあげるシーシャカフェ',
    tags: ['取扱店', 'ラウンジ'],
    image: 'https://static.readdy.ai/image/b527836e8796ae62dd89bb5aa8620183/16938d1d16a4d03e307b334186fac8e7.jpeg',
    link: 'https://www.instagram.com/humo_shisha_cafe?igsh=MTRmN29idHNzdWUyYg%3D%3D&utm_source=qr',
  },
];

function VenueCard({ venue, index }: { venue: typeof groupA[0] & { link?: string }; index: number }) {
  const handleClick = () => {
    if (venue.link) {
      window.open(venue.link, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div
      key={index}
      className={`group bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 ${venue.link ? 'cursor-pointer' : 'cursor-default'}`}
      onClick={handleClick}
    >
      <div className="relative h-56 overflow-hidden">
        <img
          src={venue.image}
          alt={venue.name}
          style={{ objectPosition: venue.name === 'Shisha Cafe humo' ? 'center 70%' : 'center center' }}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
        <div className="absolute bottom-4 left-4 flex gap-2">
          {venue.tags.map((tag, i) => (
            <span
              key={i}
              className={`px-3 py-1 rounded-full text-sm font-medium whitespace-nowrap ${
                i === 0 ? 'bg-amber-500 text-white' : 'bg-white/90 text-gray-700'
              }`}
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
      <div className="p-6">
        <div className="mb-3">
          <p className="text-amber-600 text-sm font-medium tracking-wider mb-1">{venue.area}</p>
          <h3 className="text-xl font-bold text-gray-900 leading-snug">{venue.name}</h3>
        </div>
        <p className="text-gray-500 text-base leading-relaxed mb-4">{venue.description}</p>
        <div className="flex items-center gap-2 text-gray-400 text-sm">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-map-pin-line text-sm"></i>
          </div>
          <span>{venue.address}</span>
        </div>
      </div>
    </div>
  );
}

export default function Venues() {
  return (
    <section id="venues" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-4">
            Spring Sun Bowlが<br />吸える場所
          </h2>
          <p className="text-gray-500 text-lg max-w-xl leading-relaxed">
            全国の取扱店舗でSpring Sun Bowlをご体験いただけます。お近くの店舗でぜひお試しください。
          </p>
        </div>

        {/* グループA：全てSpring Sun Bowlで提供している店 */}
        <div className="mb-14">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-3 h-3 rounded-full bg-amber-500 inline-block"></span>
            <h3 className="text-2xl font-bold text-gray-800 tracking-wide">全てSpring Sun Bowlで提供している店</h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {groupA.map((venue, index) => (
              <VenueCard key={index} venue={venue} index={index} />
            ))}
          </div>
        </div>

        {/* グループB：Spring Sun Bowlが5台存在している店 */}
        <div>
          <div className="flex items-center gap-3 mb-6">
            <span className="w-3 h-3 rounded-full bg-gray-400 inline-block"></span>
            <h3 className="text-2xl font-bold text-gray-800 tracking-wide">Spring Sun Bowlが５台提供可能な店</h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {groupB.map((venue, index) => (
              <VenueCard key={index} venue={venue} index={index} />
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}